<template>
  <div
    class="tw-flex tw-items-center tw-py-3 tw-gap-2 hover:tw-bg-light dark:hover:tw-bg-dm-light tw-px-3"
  >
    <div
      class="tw-leading-5 tw-tracking-normal"
      :style="`width: ${columns[0].width}`"
    >
      {{ company.fullname }}
    </div>

    <div :style="`width: ${columns[1].width}`">
      {{ company.ic_number }}
    </div>

    <div
      class="tw-leading-5 tw-tracking-normal"
      :style="`width: ${columns[2].width}`"
    >
      {{ company.address_street }} {{ company.address_house_number }}, {{ company.address_city }}
    </div>

    <div
      :style="`width: ${columns[3].width}`"
      class="tw-flex tw-justify-center"
    >
      <i-button
        small
        @click="$emit('select-company', company)"
      >
        {{ $t("common.actions.add") }}
      </i-button>
    </div>
  </div>
</template>

<script>
import { addCompaniesTableColumns } from '../../constants';

export default {
  name: 'AddClientsCompaniesListItem',
  props: {
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    columns() {
      return addCompaniesTableColumns;
    },
  },
};
</script>
